/* eslint-disable no-underscore-dangle */
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import SelectedFacet from './selected_facet';

const { LP, $ } = window;
const LpBoclips = LP.module('LpBoclips');
const SearchBar = LP.module('SearchBar');

const SelectedFacetsList = ({ context }) => {
  const [loadMissing, setLoadMissing] = useState(false);

  const panelStore = context.getStore('PanelStore');
  const paramStore = context.getStore('ParamStore');
  const facetStore = context.getStore('FacetStore');
  let boclipsStore;
  if (
    LpBoclips != null &&
    LpBoclips.VideoModeStore != null &&
    $('#boclips-videos-section').length === 1
  ) {
    boclipsStore = context.getStore('VideoModeStore');
  }

  const setStateFromStores = () => {
    const activeFacets = facetStore.active(paramStore.activeFacetContexts());
    const keyword = paramStore.get('keywords');
    if (keyword) {
      activeFacets.unshift({ title: keyword, key: 'keywords' });
    }

    return activeFacets;
  };

  const [facets, setFacets] = useState(setStateFromStores());

  const onChange = () => {
    setFacets(setStateFromStores());
  };

  const onPanelStoreChange = () => {
    if (panelStore._loadMissing) {
      setLoadMissing(true);
    }
  };

  useEffect(() => {
    if (loadMissing) {
      const loaded = panelStore
        .facetContextsFilteredBy('expanded')
        .concat(paramStore.extraFilters());
      const missing = paramStore
        .activeFacetContexts()
        .filter((activeFacetContext) => !Array.from(loaded).includes(activeFacetContext));
      context.executeAction(LP.module('Searches').SearchActions.loadFacets, {
        contexts: missing,
        dontAbort: true
      });
    }
  }, [loadMissing]);

  useEffect(() => {
    boclipsStore?.addChangeListener(onChange);
    facetStore.addChangeListener(onChange);
    paramStore.addChangeListener(onChange);
    panelStore.addChangeListener(onPanelStoreChange);

    return () => {
      boclipsStore?.removeChangeListener(onChange);
      facetStore.removeChangeListener(onChange);
      paramStore.removeChangeListener(onChange);
      panelStore.removeChangeListener(onPanelStoreChange);
    };
  }, []);

  if (!facets || !facets.length) return null;

  const items = facets.map((facet) => (
    <SelectedFacet key={`${facet.key}-${facet.id}`} context={context} facet={facet} />
  ));

  const resetFacets = () => {
    SearchBar.clearSearch();
    context.executeAction(LP.module('Searches').SearchActions.clearAllFilters);
  };

  return (
    <div className="selected-facets flex w-full flex-row-reverse md:flex-row">
      <div className="facet-labels -ml-1 md:ml-0 w-full md:w-auto overflow-auto">
        {items}
        <span
          onClick={resetFacets}
          className="clear-all text-primary text-sm hover:underline cursor-pointer mr-2 md:mx-1.5 pt-px mt-px whitespace-nowrap"
        >
        Clear All
      </span>
      </div>
    </div>
  );
};

SelectedFacetsList.propTypes = {
  context: PropTypes.object
};

export default SelectedFacetsList;
